// FORM GROUP VALIDATORS
import {UntypedFormGroup} from '@angular/forms';
import moment from 'moment';

export function maxDateRange(fieldKey: string, field2Key: string, max: number, type: 'seconds' | 'minutes' | 'days' | 'months' | 'years') {
  return (group: UntypedFormGroup): { [key: string]: any } | null => {
    const field1 = group.controls[fieldKey];
    const field2 = group.controls[field2Key];

    const startDate = moment(field1.value);
    const endDate = moment(field2.value);
    const diff = endDate.diff(startDate, type, true);

    console.log('date range diff: ' + diff);

    if (diff > max) {
      const errorObj = {
        maxDateRange: true
      };

      field2.setErrors(Object.assign((field2.errors || {}), errorObj));

      return errorObj;
    }

    if (diff < 0) {
      const errorObj = {
        greaterThenStart: true
      };

      field2.setErrors(Object.assign((field2.errors || {}), errorObj));

      return errorObj;
    }

    return null;
  };
}
